const req = (function() {
  const process = function(url, body, method, options = {}) {
      let retries = options.retries || 3;

      return new Promise(function(resolve, reject)  {
          const makeRequest = function (url, body, method, options) {
              const request = new XMLHttpRequest();

              request.timeout = 5 * 60000; // 5mins

              if (options.getRequest) {
                  options.getRequest(request);
              }

              const errorHandler = function(e) {
                  request.abort();
                  if (retries < 1) {
                    if (options.response) {
                        reject(request);
                    } else {
                        reject(request.response);
                    }
                  } else {
                      retries--;
                      makeRequest(url, body, method, options);
                  }
              }

              request.addEventListener('load', function(e) {
                  if (request.response && request.response.hasOwnProperty('success') && !request.response.success) {
                      if (retries < 1) {
                        if (options.response) {
                            reject(request);
                        } else {
                            if (options.request) {
                                reject(request);
                            } else {
                                reject(request.response);
                            }
                        }
                      } else {
                          retries--;
                          makeRequest(url, body, method, options);
                      }
                  } else {
                      if (options.request) {
                        resolve(request)
                      } else {
                        resolve(request.response)
                      }
                  }
              });

              request.onerror = errorHandler;
              request.ontimeout = errorHandler;

              request.upload.addEventListener('progress', function(e) {
                  const percent_complete = (e.loaded / (options.size || e.total))*100;

                  if (options.onProgress) {
                      options.onProgress(percent_complete, e.loaded);
                  }
              });

              if (!options.noResponseType) {
                  request.responseType = 'json';
              }

              request.open(method, url); 

              if (options.headers) {
                  Object.keys(options.headers).forEach(function(header) {
                      request.setRequestHeader(header, options.headers[header]);
                  })
              }

              request.send(body);
          }

          makeRequest(url, body, method, options);
      })
  }

  return {
      get: function(url, options = {}) {
          return process(url, {}, 'get', options);
      },
      post: function(url, body, options = {}) {
          return process(url, body, 'post', options);
      },
      put: function(url, body, options = {}) {
          return process(url, body, 'put', options);
      }
  }
})()

export default req;